import { Flex, Table } from 'components';
import { ActiveDot } from 'components/ActiveDot/ActiveDot';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IPlatformCompany } from 'types/platformCompany';

const CenteredCell = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
`;

interface Props {
  companies: IPlatformCompany[];
}

export const PlatformCompaniesTable: React.FC<Props> = ({ companies }) => {
  const { t } = useTranslation();

  const header = [
    t('platformCompanies.tableHeaders.active'),
    t('platformCompanies.tableHeaders.fullName'),
    t('platformCompanies.tableHeaders.shortName'),
    t('platformCompanies.tableHeaders.tenantCode'),
    t('platformCompanies.tableHeaders.database'),
    t('platformCompanies.tableHeaders.provisioning')
  ];

  const data = useMemo(
    () =>
      companies.map((company) => {
        const tenantDb = company.tenant_database;
        const provisioningLabel = tenantDb?.provisioning_error
          ? tenantDb.provisioning_error
          : tenantDb?.provisioning_step || (tenantDb?.database_provisioned ? 'ok' : '—');

        return {
          active: (
            <CenteredCell key={`active-${company.id}`}>
              <ActiveDot active={tenantDb?.active ?? false} />
            </CenteredCell>
          ),
          fullName: company.full_name,
          shortName: company.short_name,
          tenantCode: tenantDb?.id_code || '—',
          database: tenantDb?.database_config?.database || '—',
          provisioning: provisioningLabel
        };
      }),
    [companies]
  );

  return (
    <Table
      header={header}
      data={data}
      sortTable={false}
      leftFixedKeys={[1]}
      centeredColumnKeys={[0]}
    />
  );
};
